import axios from 'axios';
import Cookies from 'js-cookie';
import RuntimeActions from 'data/app-runtime/actions';
import SessionStorageUtils from 'data/session-storage/utils';
import { logErrorToDatadog } from 'utils/analytics';

 
const authFailStatusCodes = [401, 403];
const getEnv = (url) => {
    let baseURL = '';
   
  try{
    if (typeof window === "undefined"){
        return url;
 }else {
    if (window.location.href.indexOf("orf01")> -1)
        baseURL = SessionStorageUtils.PYRON_API_BASE_PATH.orf01;
    else if (window.location.href.indexOf("int03") > -1 )
        baseURL = SessionStorageUtils.PYRON_API_BASE_PATH.int03;
    else if (window.location.href.indexOf("perf01") > -1)
        baseURL = SessionStorageUtils.PYRON_API_BASE_PATH.perf01;
    else if (window.location.href.indexOf("localhost") > -1)
       return  url;
    else
        baseURL = SessionStorageUtils.PYRON_API_BASE_PATH.production;
    return baseURL+url;
   // return __COLO_URL__+url;
}
  }catch(e ){
    return url;
  }
}

const authFailed = (errResponse) => {
    console.log("authFailed ::")
    try {
        const authDest = !__DEV__ ? `?dest=${encodeURIComponent(location)}` : '';
        console.log("authDest ::"+authDest)
        const authUrl = errResponse.educatorLoginUrl
            ? errResponse.educatorLoginUrl
            :'/auth/login'

        RuntimeActions.clearState();
        SessionStorageUtils.clearStudentData();
        location = `${authUrl}${authDest}`;
    } catch (error) {
        if (process.env.NODE_ENV === 'development') {
            console.error(error);
        }
    }
};

/**
 * Will log the error to Datadog so long as the error is not a status response error from axios, or an axios generic
 * 'Network Error'.
 * @param error The error which was thrown.
 */
const logErrorToDatadogExcludingNetworkingErrors = (error) => {
    if (error) {
        let isNetworkingError =
            (error.response && error.response.status) ||
            (error.message && error.message.toLowerCase() === 'network error');
        if (!isNetworkingError) {
            logErrorToDatadog(error);
        }
    }
};

const constructErrorHandler = (optionalFailureCallback, url = null, ignoreAuthFailure = false) => {
    const failureCallback = typeof optionalFailureCallback === 'function' ? optionalFailureCallback : () => {};
    return (error) => {
        logErrorToDatadogExcludingNetworkingErrors(error);

        if (error.response && !ignoreAuthFailure && authFailStatusCodes.indexOf(error.response.status) > -1) {
            authFailed(error.response);
        } else {
            return failureCallback(error, url);
        }
    };
};

export default {
    makeGetRequest: (url, callback, queryParams = {}, failureCallback = null, timeout = null, headers = null) => {
        const requestParams = { params: queryParams };
        let authToken =__BATCH__ ==false ? sessionStorage.getItem("auth_session_Token") : null; //Cookies.get('cl-token',{ domain: '.mapnwea.org' });
        let baseURL = getEnv(url);
        // the default for axios is 1s
        if (timeout) {
            requestParams.timeout = timeout;
        }
        if(!(url.indexOf("pconf")> -1)){  
            requestParams.headers = {'Authorization': 'Bearer ' + authToken};
        }

        return axios
            .get( baseURL, requestParams)
            .then((response) => callback(response.data))
            .catch(constructErrorHandler(failureCallback, url));
    },
    makePostRequest: (
        url,
        callback,
        requestPayload,
        queryParams = {},
        failureCallback = null,
        timeout = null,
        ignoreAuthFailure = false
    ) => {
        const requestParams = { params: queryParams };
        let authToken =__BATCH__ == false ? sessionStorage.getItem("auth_session_Token") : null; 
        // the default for axios is 1s
        let baseURL = getEnv(url);
        if (timeout) requestParams.timeout = timeout;
        if(!(url.indexOf("pconf")> -1)){
            requestParams.headers = {'Authorization': 'Bearer ' + authToken};
        }
        
      
        return axios
            .post(baseURL, requestPayload, requestParams)
            .then((response) => callback(response.data))
            .catch(constructErrorHandler(failureCallback, url, ignoreAuthFailure));
    },
    makePutRequest: (url, callback, payload, queryParams, failureCallback, timeout = null) => {
        const requestParams = { params: queryParams };
        // the default for axios is 1s
        let baseURL = getEnv(url);
        if (timeout) requestParams.timeout = timeout;
        let authToken =__BATCH__ ==false ? sessionStorage.getItem("auth_session_Token") : null
        if(!(url.indexOf("pconf")> -1)){
            requestParams.headers = {'Authorization': 'Bearer '+ authToken};
        }
        return axios
            .put(baseURL, payload, requestParams)
            .then((response) => callback(response.data))
            .catch(constructErrorHandler(failureCallback, url));
    },
    makePatchRequest: (url, callback, payload, failureCallback, queryParams = null, timeout = null) => {
        const requestParams = { params: queryParams };
        // the default for axios is 1s
        let baseURL = getEnv(url);
        if (timeout) requestParams.timeout = timeout;
        let authToken =__BATCH__ ==false ? sessionStorage.getItem("auth_session_Token") : null; 
        if(!(url.indexOf("pconf")> -1)){
            requestParams.headers = {'Authorization': 'Bearer '+ authToken};
        }
        return axios
            .patch(baseURL, payload, requestParams)
            .then((response) => callback(response.data))
            .catch(constructErrorHandler(failureCallback, url));
    },
    makeDeleteRequest: (url, callback, queryParams, failureCallback, timeout = null) => {
        const requestParams = { params: queryParams };
        // the default for axios is 1s
        if (timeout) requestParams.timeout = timeout;
        let authToken =__BATCH__ ==false ? sessionStorage.getItem("auth_session_Token") : null
        if(!(url.indexOf("pconf")> -1)){
            requestParams.headers = {'Authorization': 'Bearer '+ authToken};
       }
        let baseURL = getEnv(url);
        return axios
            .delete(baseURL, requestParams)
            .then((response) => {
                callback(response.data);
            })
            .catch(constructErrorHandler(failureCallback, url));
    },
};
